export const API_USER_FAVORITES = '/api/user/articles/saved';
export const API_USER_FAVORITES_ID = '/api/user/articles/saved/:id';
